module.exports = __webpack_public_path__ + "img/si.8ebd49ef.svg";